import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Layout } from '@loadsmart/miranda-react'

import { EmptyStateWrapper } from './EmptyState.styles'

export function EmptyShipmentsListState() {
  return (
    <EmptyStateWrapper>
      <Layout.Stack gap="spacing-4" align="center">
        <EmptyState title="You have no active shipments in your list" variant="page" />
      </Layout.Stack>
    </EmptyStateWrapper>
  )
}
